import { api } from "../client";
import { CampaignOpportunityChangelog } from "../schema/CampaignOpportunityChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<CampaignOpportunityChangelog[]>;

export const getCampaignOpportunityChangelog = async (
  campaignOpportunityId: number,
  config?: ApiRequestConfig
) => {
  return api.get<CampaignOpportunityChangelog[]>(
    `campaign_opportunities/${campaignOpportunityId}/campaign_opportunity_histories`,
    config
  );
};
